export const ACCOUNT_OWNER_INDIVIDUAL_BY_NAME = "Individual by name";
export const ACCOUNT_OWNER_TRUST = "Trust";
export const ACCOUNT_OWNER_BUSINESS = "Business";
export const ACCOUNT_OWNER_CHARITY = "Charity";
export const ACCOUNT_OWNER_NOT_SURE = "I'm not sure";
export const ACCOUNT_OWNER_INDIVIDUAL_BY_NAME_DESC =
  "Select individual by name if you and/or your partner own this account. This option includes joint ownership.";
export const ACCOUNT_OWNER_TRUST_DESC =
  "Select trust if this account has been titled in the name of a trust.";
export const ACCOUNT_OWNER_BUSINESS_DESC =
  "Select business if this account has been titled in the name of a business.";
export const ACCOUNT_OWNER_CHARITY_DESC =
  "Select charity if this account has been titled in the name of a charity and the charity is the legal owner.";
export const ACCOUNT_OWNER_NOT_SURE_DESC =
  "If you're not sure how this account is titled, select this option to skip this step. You'll be able to come back to it later.";
export const ACCOUNT_OWNER_SECTION_DESC = (accountType: string): string => {
  return `Asset titling indicates ownership of this ${accountType}. Select the option that best describes how this account is titled. You will then be prompted to choose an owner.`;
};
